import { useState } from "react";
import "./quick-replies.css";

export interface QuickExtra {
  id: string;
  label: string;
}

/** Tappable answers under Iris's question. Tapping is easier than typing; talking still works. */
export function QuickReplies({
  options,
  multi,
  extras = [],
  disabled = false,
  onAnswer,
  onExtra,
  continueLabel,
}: {
  options: string[];
  multi: boolean;
  extras?: QuickExtra[];
  disabled?: boolean;
  onAnswer: (text: string) => void;
  onExtra?: (id: string) => void;
  continueLabel: string;
}) {
  const [picked, setPicked] = useState<string[]>([]);
  const toggle = (option: string) =>
    setPicked((current) => (current.includes(option) ? current.filter((item) => item !== option) : [...current, option]));
  return (
    <div className="quick-replies" role="group" aria-label="Quick answers">
      {options.map((option) => {
        const on = picked.includes(option);
        return (
          <button
            key={option}
            type="button"
            className={`quick-chip${on ? " on" : ""}`}
            disabled={disabled}
            aria-pressed={multi ? on : undefined}
            onClick={() => (multi ? toggle(option) : onAnswer(option))}
          >
            {on && <span aria-hidden="true">✓ </span>}
            {option}
          </button>
        );
      })}
      {multi && options.length > 0 && (
        <button
          type="button"
          className="quick-chip quick-next"
          disabled={disabled || !picked.length}
          onClick={() => onAnswer(picked.join(", "))}
        >
          {continueLabel}
        </button>
      )}
      {extras.map((extra) => (
        <button key={extra.id} type="button" className="quick-chip quick-extra" disabled={disabled} onClick={() => onExtra?.(extra.id)}>
          {extra.label}
        </button>
      ))}
    </div>
  );
}
